import React from 'react';
import { ChevronRight } from 'lucide-react';
import type { Procedure } from '../data/constants.js';
import { C } from '../data/constants.js';

interface ProcedureRowProps {
  proc: Procedure;
  onClick: () => void;
  index: number;
}

export function ProcedureRow({ proc, onClick, index }: ProcedureRowProps): React.ReactElement {
  return (
    <div
      onClick={onClick}
      style={{
        display: 'grid',
        gridTemplateColumns: '1fr 140px 180px 60px 80px 70px 40px',
        alignItems: 'start',
        padding: '14px 16px',
        borderBottom: `1px solid ${C.cardBorder}`,
        cursor: 'pointer',
        transition: 'background 0.15s',
        animation: `insights-fadeSlideUp 0.4s ease ${index * 40}ms both`,
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = 'rgba(0,207,160,0.03)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = 'transparent';
      }}
    >
      <div>
        <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.85)', fontWeight: 500 }}>
          {proc.name}
        </div>
        <div style={{ fontSize: 11, color: C.textDim, marginTop: 2 }}>
          {proc.surgeon}
          {proc.specialty ? ` \u00B7 ${proc.specialty}` : ''}
        </div>
      </div>
      <span style={{ fontSize: 12, color: C.textMid }}>{proc.date}</span>
      <span style={{ fontSize: 12, color: C.textMid }}>{proc.or || '—'}</span>
      <span style={{ fontSize: 12, color: C.textMid, fontFamily: "'Space Mono', monospace" }}>
        {proc.duration}m
      </span>
      <span style={{ fontSize: 12, color: C.orange, fontFamily: "'Space Mono', monospace" }}>
        {proc.wasteCost != null ? `$${proc.wasteCost}` : '—'}
      </span>
      <span style={{ fontSize: 12, color: C.accent, fontFamily: "'Space Mono', monospace" }}>
        {proc.deadTime != null ? `-${proc.deadTime}m` : `${proc.stepsCompleted}/${proc.steps}`}
      </span>
      <ChevronRight size={14} color={C.textFaint} />
    </div>
  );
}
